<template>
  <ul class="homeUl">
    <!-- class="wow animate__slideInUp"
      :data-wow-delay="`${idx / 10}s`" -->
    <li
      class="wow animate__slideInUp"
      :data-wow-delay="`${idx / 10}s`"
      :key="idx"
      v-for="(item, idx) in News"
    >
      <div class="homeUlLeft">
        <span class="homeDot"></span>
        <div>
          <h3>
            <router-link :to="`/newsContent?id=${item.Id}`">{{
              item.Title
            }}</router-link>
          </h3>
          <div class="show-xs">
          <div class="other">
        <span class="month">{{ moment(item.PubDate).year() }}-{{ moment(item.PubDate).format("MM-DD") }}</span>
      </div>
    </div>
          <p>{{ item.Summary }}</p>
        </div>
      </div>
      <div class="other show-xm">
        <span class="month">{{ moment(item.PubDate).format("MM-DD") }}</span>
        <span>{{ moment(item.PubDate).year() }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          title: "将文化融入设计 以设计推动创新",
          discrap:
            "2013年11月13日，装饰有限公司联合北京大学政府管理学院承办了...",
          month: "03-10",
          year: "2020",
        },
        {
          title: "将文化融入设计 以设计推动创新",
          discrap:
            "2013年11月13日，装饰有限公司联合北京大学政府管理学院承办了...",
          month: "03-10",
          year: "2020",
        },
        {
          title: "将文化融入设计 以设计推动创新",
          discrap:
            "2013年11月13日，装饰有限公司联合北京大学政府管理学院承办了...",
          month: "03-10",
          year: "2020",
        },
      ],
      moment: this.$moment,
    };
  },
  props: ["News"],
};
</script>

<style lang="scss">
.homeUl {
  width: 100%;
  border-top: 1px solid #bfbfbf;
  list-style-type: circle;
  li {
    display: flex;
    transition: all 0.5s;
    justify-content: space-between;
    align-items: center;
    padding: 30px 20px;
    border-bottom: 1px solid #bfbfbf;
    position: relative;
    .homeUlLeft {
      display: flex;
      align-items: top;
    }
    h3 {
      padding: 0 0 20px 0;
    }
    .homeDot {
      display: inline-block;
      vertical-align: middle;
      width: 6px;
      height: 6px;
      line-height: 6px;
      border-radius: 50%;
      background-color: #bfbfbf;
      margin-right: 10px;
      margin-top: 8px;
      flex-shrink: 0;
    }
    .other {
      min-width: 60px;

      transition: all 0.5s;
      span {
        display: block;
        text-align: center;
      }
    }
    .month {
      font-size: 20px;
      padding-bottom: 10px;
    }
    &:hover {
      padding-left: 50px;
      h3 {
        color: #d71820;
      }
      .homeDot {
        background: #d71820;
      }
      .other {
        margin-right: 10px;
      }
    }
  }
}
</style>